<template>
  <Badge
    :color="color"
    :border="border"
    @click="$emit('click')"
    @blur="$emit('blur')"
    @focus="$emit('focus')"
  >
    <slot></slot>
    <template v-slot:icon>
      <PlusIcon :color="color" size="small"></PlusIcon>
    </template>
  </Badge>
</template>
<script>
import { Badge, PlusIcon } from '@mikmak/components';

export default {
  data() {
    return {
      color: '#4369F4',
      border: '1px dashed #C1CCD4',
    };
  },
  components: {
    Badge,
    PlusIcon,
  },
};
</script>
